export const coreEnrollmentArray = [
	"Health Plan",
	"Clinic Card",
	"Group Short Term Disability",
	"Group Long Term Disability(Class 1)",
	"Group Long Term Disability(Class 2)",
	"KSOP",
	"Helping Our Own",
	"Christmas Club Election",
	"Group Life Insurance"
];

export const coreEnrollmentNext = {
	"Health Plan": null,
	"Clinic Card": "Group Short Term Disability",
	"Group Short Term Disability": "Group Long Term Disability(Class 1)",
	"Group Long Term Disability(Class 1)": "Group Long Term Disability (Class 2)",
	"Group Long Term Disability(Class 2)": "KSOP",
	KSOP: "Helping Our Own",
	"Helping Our Own": "Christmas club Election",
	"Christmas Club Election": "Group Life Insurance",
	"Group Life Insurance": "finish"
};

export const buttonCaptionShortNames = {
	"Health Plan": "HP",
	"Clinic Card": "CC",
	"Group Short Term Disability": "GSTD",
	"Group Long Term Disability(Class 1)": "GLTD(Class1)",
	"Group Long Term Disability(Class 2)": "GLTD(Class2)",
	KSOP: "KSOP",
	"Helping Our Own": "HOO",
	"Christmas Club Election": "CCE",
	"Group Life Insurance": "GLI"
};
